import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, Event } from '@angular/router';
import { APIError } from '../../shared/shared.models';
import { AnonMapService } from '../../shared/models/map-services.model';
import { MapServicesService } from '../../shared/services/map-services.service';
import { UtilsService } from '../../shared/utils/utils.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-datasets',
  templateUrl: './datasets.component.html',
  styleUrls: ['./datasets.component.scss'],
})
export class DatasetsComponent implements OnInit {
  onDestroy$ = new Subject();
  mapServiceSlug: string; // unique ID for the service
  apiError: APIError = new APIError();
  dataset: any = null;
  loading: boolean = true;
  countryNames: Array<string> = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    private utilsService: UtilsService,
    private mapServicesService: MapServicesService,
    private router: Router,
  ) {
    this.router.events.pipe(takeUntil(this.onDestroy$)).subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.initData();
      }
    });
  }

  ngOnInit() {
    // Get Map Service
    this.initData();
  }

  initData(): void {
    this.loading = true;
    this.dataset = {} as AnonMapService;
    this.mapServiceSlug = this.activatedRoute.snapshot.paramMap.get('mapServiceSlug');
    if (this.mapServiceSlug) {
      this.setMapServiceDetails(this.mapServiceSlug);
    }
  }

  /**
   * Store unique country names in array
   */
  getUniqueCountryNames() {
    // The GeoJSON also contains the names of the countries so store these and display to user
    // Because this function gets called regularly by OpenLayers when it updates the map,
    // we need to exclude any countries that were already in the list
    // Also, one 'country name' could relate to multiple ISO codes. For example: 'Denmark including Greenland and Faroe Islands'
    this.countryNames = [];
    this.dataset.mapServiceMetadata.coverage.map((country) => {
      if (!this.countryNames.includes(country.name)) {
        this.countryNames.push(country.name);
      }
    });
  }

  /**
   * Set service
   */
  setMapServiceDetails(mapServiceSlug: string): void {
    this.mapServicesService
      .getAnonMapServiceDetails(mapServiceSlug)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.dataset = data;
          this.getUniqueCountryNames();
          if (mapServiceSlug === 'cadastral-all') {
            this.loadAtomFeedScript();
          }
        },
        (error) => {
          this.apiError = this.utilsService.handleAPIError(error);
        },
        () => {
          this.loading = false;
        },
      );
  }

  loadAtomFeedScript(): void {
    var headID = document.getElementsByTagName('head')[0];
    this.dataset.mapServiceMetadata.cadastralProviderLinks.map((item) => {
      item.links.map((link) => {
        var linkElement = document.createElement('link');
        linkElement.type = 'application/atom+xml';
        linkElement.rel = 'alternate';
        linkElement.title = item.country + ' ' + link.product;
        headID.appendChild(linkElement);
        linkElement.href = link.productURL;
      });
    });
  }

  /**
   * @returns void
   */
  ngOnDestroy(): void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }
}
